import {decode} from 'html-entities';
export default function Question(props) {
    
    // console.log(props)
    const stylesSelected = { 

        border:"none",
        color: "#293264",
        backgroundColor:  "#D6DBF5" 
    }
    const wrongAns = { 

        border:"none",
        color: "#293264",
        backgroundColor:  '#F8BCBC'
    }
    const correctAns = { 

        border:"none",
        color: "#293264",
        backgroundColor:  '#94D7A2'
    }
    const handleReplace = (str) =>{
          let finalStr =  str.replace(/&quot;/g, '"')
          

          return finalStr
    }
    let options = []
    options.push(...props.incorrect_answers)
    options.push(props.correct_answer)
   
  const decoder = (text) =>{
    text = "'" + text + "'"
    return decode(text)
  }
     

  return (
    
    <div className='question-opt-container'>
            <div className = 'container'>
             <h2 className="question">{decoder(props.qdata)}</h2>
             <div className ='btn-container'>
                { props.gameOver === false ? options.map(option => <button 
                                        onClick = {() => {
                                            props.selectedOption(props.id,option)
                                        }} 
                                        className = "btn-option" 
                                        style = {option === props.selected ? stylesSelected : null  }
                                        
                                        >
                                        {decoder(option)}
                                        </button>) : 
                                        
                                        options.map(option => <button 
                                            onClick = {() => {
                                                props.selectedOption(props.id,option)
                                            }} 
                                            className = "btn-option" 
                                            style = {props.correct_answer === option?  correctAns :(option === props.selected && !props.isAnswerCorrect ?  wrongAns :  null)}
                                           
                                            
                                            >
                                            {decoder(option)}
                                            </button>) }
            </div>       
            
            <hr></hr> 
            </div>
     
    </div>
  )
}